import React from 'react';
import type { AddressFields, AddressValues } from './types';

type Props = {
  fields: AddressFields;
  values: AddressValues;
  onChange: (key: string, val: string) => void;
};

const normalizeOptions = (opts?: AddressFields[string]['options']) => {
  if (!opts) return [];
  if (Array.isArray(opts)) return opts;
  return Object.entries(opts).map(([value, label]) => ({ value, label }));
};

export const AddressForm: React.FC<Props> = ({ fields, values, onChange }) => {
  return (
    <div className="ips-front-address-form">
      {Object.entries(fields).map(([key, field]) => {
        const val = values[key] ?? '';
        const label = field.label || key;
        const required = !!field.required;
        const options = normalizeOptions(field.options);
        const inputType = field.type || 'text';

        if (options.length > 0) {
          return (
            <label key={key} className="ips-front-address-form__row">
              <span>{label}{required ? ' *' : ''}</span>
              <select value={val} onChange={(e) => onChange(key, e.target.value)} required={required}>
                <option value="">{field.placeholder || '—'}</option>
                {options.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </label>
          );
        }

        return (
          <label key={key} className="ips-front-address-form__row">
            <span>{label}{required ? ' *' : ''}</span>
            <input
              type={inputType === 'email' ? 'email' : 'text'}
              value={val}
              placeholder={field.placeholder || ''}
              required={required}
              onChange={(e) => onChange(key, e.target.value)}
            />
          </label>
        );
      })}
    </div>
  );
};
